<div class="script" [class.web]="isWeb()">
  <div>
    <div class="title">
      <app-image [name]="icon()" alt="script" [isIcon]="true" [local]="true" />
      <h3>{{ title() }}</h3>
    </div>
    <div class="description">{{ description() }}</div>
  </div>
  <app-button (click)="onActionClick()" [label]="button()!" [disabled]="!enabled()" />
</div>